<template>
  <div class="start">

    <send-sample-dialog
      v-if="$route.hash?.startsWith('#demo:')"
      sample-id="64c9dff3-2ac5-47a3-ac87-a52d560fb76f"
      :hash-prefix="$route.hash.split(':')[0]"
    />

    <start-header
      :media="{ id: '24acb33c-73b9-4115-afdb-8855cce1c126', alt: 'Gift cards', video: true }"
      :bg="{ src: 'https://cdn.ellacard.com/media/61ce9982-fda2-4358-a0e6-0c55e55cf523/lg.webp', color: '#d4c9b1' }"
      :to="{ name: 'catalog-gift-cards' }"
    >
      <template v-slot:h1>Gift cards from thousands of international merchants</template>
    </start-header>

    <start-layer clip-waves-class="light-gradient" :offset=".75">

      <div class="actions">
        <v-btn class="btn-pop" x-large rounded dark color="ec-blue" :to="{ name: 'catalog-gift-cards' }">Send a gift card <v-icon class="mr-n1" v-html="mdiChevronRight" /></v-btn>
        <v-btn class="btn-pop" x-large rounded dark color="pink" :to="{ hash: '#demo:sign' }">Try demo…</v-btn>
      </div>

      <div class="grid-alternate">

        <div class="relative hover-pop-group" style="aspect-ratio: 8 / 7;">
          <web-media
            class="absolute r3 white"
            style="width: 46%; top: 0; right: 5%;"
            aspect-ratio="5 / 7"
            id="a79d0593-dcdd-40cd-9899-e398be72035f" alt="Example card page with group gift card"
          />
          <img
            class="absolute d-block rn3 white"
            style="width: 46%; top: 0; left: 5%;"
            aspect-ratio="5 / 7"
            type="image/webp" loading="lazy"
            src="https://ellacard-public.s3.amazonaws.com/r/2fff1d48-02e7-4299-98ad-28e7c05d5113"
            alt="Example card cover"
          />

          <web-media
            class="absolute has-alpha rn3"
            style="width: 28%; bottom: 6%; left: 0;"
            aspect-ratio="1"
            id="63609de6-95da-4c9e-900a-444fba1fae27" alt="Contributor headshot"
          />

          <v-btn style="width: 90px; bottom: 0; left: calc(14% - 45px);" absolute large rounded dark color="green lighten-2">$50</v-btn>

          <web-media
            class="absolute has-alpha rn3"
            style="width: 28%; bottom: 2%; left: 36%;"
            aspect-ratio="1" id="ca2c0da0-b561-4d1d-b5e8-4dd1afac766d" alt="Contributor headshot"
          />

          <v-btn style="width: 90px; bottom: -4%; left: calc(50% - 45px);" absolute large rounded dark color="green lighten-2">$100</v-btn>

          <web-media
            class="absolute has-alpha rn3"
            style="width: 28%; bottom: 6%; left: 72%;"
            aspect-ratio="1" id="b8b5faa5-fa27-4902-92e6-58d0350a0872" alt="Contributor headshot"
          />

          <v-btn style="width: 90px; bottom: 0; right: calc(14% - 45px);" absolute large rounded dark color="green lighten-2">$100</v-btn>

        </div>

        <div>
          <h4 class="mb-3"><v-icon v-html="mdiAccountGroup" /> Group gift cards</h4>
          <div>
            Groups can add value idependently to a single gift card – no one has to deal with getting paid back. Make contributions private to let your group donate what they're comfortable with.
          </div>
        </div>

        <v-lazy style="aspect-ratio: 4 / 3;">
          <div class="relative hover-pop-group" style="aspect-ratio: 4 / 3;">

            <web-media class="absolute hover-pop has-alpha rn3" style="aspect-ratio: 144 / 171; width: 30%; left: 0; top: 2%;" id="d112328a-fdd3-4b53-963f-0271b45358e8" alt="Example gift card thank you text message to Luke" />

            <web-media class="absolute hover-pop has-alpha r1" style="aspect-ratio: 144 / 171; width: 30%; left: 23.3%; top: 0;" id="2922c5d6-62dd-4a71-b1a1-fac84ec53e6b" alt="Example gift card thank you text message to Jessie" />

            <web-media class="absolute hover-pop has-alpha rn2" style="aspect-ratio: 144 / 171; width: 30%; left: 46.7%; top: 2%;" id="fc3f2211-06c3-4365-a3e7-eb8b12b694ec" alt="Example gift card thank you text message to Teresa" />

            <div class="absolute hover-pop r5 pa-2 grey lighten-4" style="width: 30%; left: 70%; top: 0;">
              <web-media class="elevation-1" style="aspect-ratio: 128 / 168;" id="a4bc8618-9d28-4f22-942b-6153f28cc14c" alt="Example gift card thank you email to Andrew" />
            </div>

            <web-media class="absolute white hover-pop r5" style="aspect-ratio: 5 / 7; width: 36%; left: 57%; bottom: 0;" id="ff6b8278-5731-4284-9b0e-6b3b2a7550e6" alt="Example gift card thank you page 3" />
            <web-media class="absolute white hover-pop" style="aspect-ratio: 5 / 7; width: 36%; left: 32%; bottom: 0;" id="0f042492-29dd-441d-a86d-c90768618526" alt="Example gift card thank you page 2" />
            <web-media class="absolute white hover-pop rn5" style="aspect-ratio: 5 / 7; width: 36%; left: 7%; bottom: 0;" id="731c8c24-2186-4b99-9ea2-d27740545bb8" alt="Example gift card thank you page 1" />

          </div>
        </v-lazy>

        <div>
          <h4 class="mb-3"><v-icon v-html="iconPathTextEmail" /> Multiple recipients</h4>
          <div>
            Send gift cards to multiple recipients via text or email – the easiest way to say "thank you" to a group all at once.
          </div>
        </div>

        <web-media
          class="hover-pop rounded-xl white"
          aspect-ratio="16 / 9"
          id="4c484036-9f33-4725-b6c1-0509f97a02ef"
          alt="Automation"
          is-video
        />

        <div>
          <h4 class="mb-3"><v-icon v-html="mdiCalendar" /> Bulk scheduling automation</h4>
          <div>
            Schedule gift cards to send to multiple recipients on different dates – perfect for automating rewards for employee birthdays or work anniversaries.
          </div>
        </div>

        <div class="relative hover-pop-group" style="aspect-ratio: 4 / 3;">
          <web-media
            class="absolute rounded-xl white"
            style="width: 96%; top: 15%; left: 0;"
            aspect-ratio="16 / 9"
            id="24acb33c-73b9-4115-afdb-8855cce1c126"
            alt="Gift cards for thousands of international merchants"
            is-video
          />
          <web-media
            class="absolute rounded r2 white"
            style="top: 0; right: 0; width: 30%;"
            aspect-ratio="144 / 362"
            id="6e32527b-7257-450e-8bc1-604e30897c8d"
            alt="Gift card country list"
          />
        </div>

        <div>
          <h4 class="mb-3"><v-icon v-html="mdiCardMultiple" /> Thousands of merchants</h4>
          <div>
            Ellacard carries gift cards from top merchants like <router-link :to="{ name: 'catalog-gift-cards', params: { providerId: 'RU:AMZ-US' } }">Amazon</router-link>, <router-link :to="{ name: 'catalog-gift-cards', params: { providerId: 'TR:DC82VBYLI4CC' } }">Apple</router-link>, <router-link :to="{ name: 'catalog-gift-cards', params: { providerId: 'RU:SBUX-US' } }">Starbucks</router-link>, <router-link :to="{ name: 'catalog-gift-cards', params: { providerId: 'RU:DDASH-US' } }">Doordash</router-link>, and more in countries / currencies around the world. Or let the <router-link :to="{ name: 'catalog-gift-cards', params: { providerId: 'TR:ANY-USD' } }">recipient choose</router-link>.
          </div>
        </div>

        <web-media
          class="hover-pop rounded-xl white"
          aspect-ratio="4 / 3"
          id="2a4bba3d-c1c9-4426-84b3-deb3804ff154"
          alt="Example gift card opening experience"
          is-video
        />

        <div>
          <h4 class="mb-3"><v-icon v-html="mdiGift" /> Perfect presentation</h4>
          <div>
            Your gift card comes wrapped inside an Ellacard, complete with whatever custom effects you want for the best recipient experience.
          </div>
        </div>

      </div>

      <div class="actions">
        <v-btn class="btn-pop" x-large rounded dark color="ec-blue" :to="{ name: 'catalog-gift-cards' }">Send a gift card <v-icon class="mr-n1" v-html="mdiChevronRight" /></v-btn>
        <v-btn class="btn-pop" x-large rounded dark color="pink" :to="{ hash: '#demo:sign' }">Try demo…</v-btn>
      </div>

    </start-layer>

    <start-layer clip-waves-class="dark-gradient" :offset=".9">
      <h2>Getting started</h2>

      <div class="grid-alternate">

        <div class="relative hover-pop-group" style="aspect-ratio: 4 / 3;">
          <web-media class="white absolute rounded rn3" style="width: 70%; top: 0; left: 0;" aspect-ratio="640 / 606" id="64cb0041-0dd8-4f35-b757-869df3ef545e" alt="Gift card catalog" />
          <web-media class="white absolute rounded" style="width: 80%; bottom: 0; right: 0;" aspect-ratio="16 / 9" id="bdd30b81-701c-43b4-95a9-45b81d0b82fe" alt="Add gift card button" />
        </div>

        <div>
          Choose a gift card from our <router-link class="white--text" :to="{ name: 'catalog-gift-cards' }">gift card catalog</router-link>, or start with a <router-link class="white--text" :to="{ name: 'catalog' }">greeting card design</router-link> and use the <div class="relative d-inline-block" style="width: 32px;"><v-btn style="left: 0; top: calc(50% - 16px);" absolute x-small fab dark color="green lighten-2"><v-icon v-html="mdiWalletGiftcard" /></v-btn>&nbsp;</div> button to add a gift card when customizing it.
        </div>

        <web-media
          class="white d-block hover-pop rounded"
          aspect-ratio="1432 / 652"
          id="b336db73-bd89-40f8-8803-71b80088653d"
          alt="Bulk scheduling automation with Ellacard contacts"
          title="Batch order tool"
          :to="{ name: 'batch-order' }"
        />

        <div>
          To schedule gift cards to send to multiple recipients on different dates, use our <router-link class="white--text" :to="{ name: 'batch-order' }">bulk-scheduling tool</router-link>.
        </div>

      </div>
    </start-layer>

    <start-reviews tag="GI" />

    <start-footer />

  </div>
</template>


<script>
import SendSampleDialog from '@/components/SendSampleDialog.vue';
import StartHeader from '@/components/StartHeader.vue';
import StartFooter from '@/components/StartFooter.vue';
import StartLayer from '@/components/StartLayer.vue';
import StartReviews from '@/components/StartReviews.vue';
import WebMedia from '@/components/WebMedia.vue';
import iconPathTextEmail from 'raw-loader!@/assets/icon-path-text-email.txt';
import { mdiAccountGroup, mdiCalendar, mdiGift, mdiWalletGiftcard, mdiCardMultiple, mdiChevronRight } from '@mdi/js';


export default {
  name: 'start-gift-cards',

  routerViewMeta: {
    $class: 'fade-transparent',
    $subtitle: 'Gift cards',
    description: 'Gift cards from thousands of international merchants'
  },

  components: {
    SendSampleDialog,
    StartFooter,
    StartHeader,
    StartLayer,
    StartReviews,
    WebMedia
  },

  created() {
    Object.assign(this, { iconPathTextEmail, mdiAccountGroup, mdiCalendar, mdiGift, mdiWalletGiftcard, mdiCardMultiple, mdiChevronRight });
  }
}
</script>
